import { useCallback, useState } from 'react'

import { RequestStatus } from 'core/domain/Request'

import { sentry } from 'legacy/utils/sentry'

import {
  createAndAssignTractorNumber,
  type CreateAndAssignTractorNumberParams,
} from '../../use-cases/createAndAssignTractorNumber'

export function useCreateAndAssignTractorNumber() {
  const [requestStatus, setRequestStatus] = useState(RequestStatus.Initial)

  const createAndAssignTractor = useCallback(
    async ({ carrierUUID, shipmentUUID, tractorNumber }: CreateAndAssignTractorNumberParams) => {
      setRequestStatus(RequestStatus.Pending)
      try {
        await createAndAssignTractorNumber({ carrierUUID, shipmentUUID, tractorNumber })
        setRequestStatus(RequestStatus.Done)
      } catch (error) {
        sentry.log(error)
        setRequestStatus(RequestStatus.Error)
      }
    },
    []
  )

  return { createAndAssignTractor, requestStatus }
}
